// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"bc5cf1ce0949818c574f","532":"451464f95f2c28a1a040","589":"155f7906888c2eaea626","678":"d70c2b8d9f400bd4cc52","883":"ae508ae653c9595ad6d3"}[chunkId] + ".js";
};